import { Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { getUserInputForStepId } from "../../../components/wizard/util";
import { parseAsSelectionAlternative } from "../../../components/data-presentation/util";
import theme from "../../../components/theme/theme";
import { makeStyles, createStyles } from "@mui/styles";
import { baseApiUrl } from "../../../base";
import useWizard from "../../../common/hooks/useWizard";
import GridClimateInfoAngular from "./grid-info-angular";

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: "15px",
    },
  })
);

export default function GridClimateInfo() {
  const classes = useStyles(theme);

  const { customer, economicProfile } = useParams();

  let { steps: wizardSteps, wizardIsCompleted } = useWizard(
    customer!,
    economicProfile!
  );
  const district = parseAsSelectionAlternative(
    getUserInputForStepId("DistrictSelected", wizardSteps)?.at(0)?.value
  )?.value;
  const building = parseAsSelectionAlternative(
    getUserInputForStepId("BuildingProfile", wizardSteps)?.at(0)?.value
  )?.value;

  return wizardIsCompleted ? (
    <div>
      <Typography variant="h1">Elsystemet</Typography>
      <Paper className={classes.card} elevation={3} sx={{ mb: 3 }}>
        <Typography paragraph>
          Elsystemet är ett sammankopplat system där ett ökat eller minskat
          behov av el på aktuell ort kan påverka elkraftsanläggningar i hela
          nordeuropa. Första diagrammet nedan visar hur elproduktionen i det
          nordeuropeiska elsystemet ser ut under ett helt år.
        </Typography>
        <Typography paragraph>
          Vid ett ökat elbehov, exempelvis för värmepumpar som
          uppvärmningsalternativ, beräknar klimatmodulen samtliga
          utsläppskonsekvenser som uppstår i elsystemet baserat på hur
          elsystemet kan se ut under uppvärmningsalternativets livslängd, dvs de
          kommande 20 åren. Läs mer om detta under "Om beräkningen". Vilka
          elkraftsanläggningar och därmed vilka bränslen som påverkas i
          elsystemet när elbehovet ökar framgår av det andra diagrammet nedan.
        </Typography>
      </Paper>
      <GridClimateInfoAngular
        customer={customer}
        district={district}
        building={building}
        economicProfile={economicProfile}
        api={baseApiUrl}
      />
    </div>
  ) : (
    <></>
  );
}
